<template>
  <div>

    <div class="has-text-centered mb-6" v-if="init.name || init.subname">
      <h1 class="title is-3" v-if="init.name">{{init.name}}</h1>
      <h2 class="subtitle is-5" v-if="init.subname">{{init.subname}}</h2>
    </div>

    <div class="tabs is-centered is-boxed">
      <ul>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
            <span>Informazioni</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">
          
        <form class="columns is-multiline" @submit.prevent="order._id ? updateOrder() : saveOrder()">

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Data</label>
              <div class="control">
                <input class="input" type="date" placeholder="Data" v-model="order.date" required />
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Utente"
              v-model="order.user"
              :options="$store.getters.users"
              :disabled="true"
              id="_id"
              track-by="_id"
              :custom-label="$fullname"
            />
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Fornitore" v-model="order.supplier" />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label" for="to_invoice">Ordinato</label>
              <div class="control">
                <input type="checkbox" id="to_invoice" v-model="order.isRequested">
              </div>
            </div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12">
            <div class="field">
              <label class="label has-text-centered is-size-4">Prodotti</label>
              <div class="has-text-right">
                <button class="button is-success" type="button" @click="selectProduct()"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Produttore</th>
                        <th>Codice</th>
                        <th>Descrizione</th>
                        <th>Unità</th>
                        <th style="width: 180px;">Prezzo listino unitario</th>
                        <th style="width: 100px;">Sconto %</th>
                        <th style="width: 180px;">Prezzo scontato</th>
                        <th style="width: 80px;">Quantità</th>
                        <th style="width: 120px;">Totale</th>
                        <th>Destinazione</th>
                        <th style="width: 50px;">Ricevuto</th>
                        <th style="width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in order.products" :key="index">
                          <td data-label="Produttore">
                            {{ product.brand }}
                          </td>
                          <td data-label="Codice">
                            {{ product.code }}
                          </td>
                          <td data-label="Descrizione">
                            {{ product.name }}
                          </td>
                          <td data-label="Unità">
                            {{ product.unit }}
                          </td>
                          <td data-label="Prezzo listino unitario">
                            <input class="input" type="text" placeholder="Prezzo listino unitario" v-model="product.price" />
                          </td>
                          <td data-label="Sconto %">
                            <input class="input" type="text" placeholder="Sconto %" v-model="product.discount" />
                          </td>
                          <td data-label="Prezzo scontato">
                            <input class="input" type="text" placeholder="Prezzo scontato" :value="calcDiscountedPrice(product)" readonly />
                          </td>
                          <td data-label="Quantità">
                            <input class="input" type="text" placeholder="Quantità" v-model="product.quantity" />
                          </td>
                          <td data-label="Totale">
                            <div style="white-space: nowrap;">{{calcProductTotal(product)}}</div>
                          </td>
                          <td data-label="Destinazione">
                            <div v-for="(link, index) in product.linked" :key="index" class="mb-2">
                              <OperationLabel v-if="link.operation" :operation="link.operation" @delete="removeOperationFromOrder(product, index)" v-model:quantity="link.quantity" :customPrice="link.customPrice" :listPrice="product.lastSalePrice || product.price" :vat="getValidVat(link.vat)" :vatTotal="calcLinkedVatTotal(link, product)" @editPrice="openEditPriceModal(link, product)" />
                              <DirectLabel v-if="link.direct" :direct="link.direct" @delete="removeOperationFromOrder(product, index)" v-model:quantity="link.quantity" :customPrice="link.customPrice" :listPrice="product.lastSalePrice || product.price" :vat="getValidVat(link.vat)" :vatTotal="calcLinkedVatTotal(link, product)" @editPrice="openEditPriceModal(link, product)" />
                            </div>
                            <div class="has-text-centered buttons" :class="{'my-3': product.linked?.length}">
                              <button class="button is-success" type="button" @click="openAddOperationModal(product)" title="Aggiungi">
                                <font-awesome-icon icon="plus" /> Appuntamento
                              </button>
                              <button class="button is-success" type="button" @click="openAddDirectModal(product)" title="Aggiungi">
                                <font-awesome-icon icon="plus" /> Vendita
                              </button>
                            </div>
                          </td>
                          <td data-label="Ricevuto">
                            <label class="checkbox">
                              <input type="checkbox" v-model="product.isReceived">
                            </label>
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button class="button is-danger" type="button" @click="order.products = order.products.filter((p, pIndex) => pIndex !== index)" title="Elimina">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="order.products.length === 0">
                          <td colspan="100" class="has-text-centered has-text-grey">
                            <i>Nessun risultato</i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="has-text-right mt-3">
              <h4 class="title is-4">Totale ordine: {{calcOrderTotal()}}</h4>
            </div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12">
            <div class="field">
              <label class="label has-text-centered is-size-4">Bolle</label>
              <div class="has-text-right">
                <button class="button is-success" type="button" @click="addShippingNote()" :disabled="!order?._id"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Numero</th>
                        <th>Data</th>
                        <th>Allegato</th>
                        <th style="min-width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(shippingNote, index) in order.shippingNotes" :key="index">
                          <td data-label="Numero">
                            <input class="input" type="text" placeholder="Numero" v-model="shippingNote.number" />
                          </td>
                          <td data-label="Data">
                            <input class="input" type="date" placeholder="Data" v-model="shippingNote.date" />
                          </td>
                          <td data-label="Allegato">
                            <div v-if="!shippingNote.attachment" class="file">
                              <label class="file-label">
                                <input class="file-input" type="file" ref="inputFiles" @change="uploadFile(shippingNote)">
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <font-awesome-icon icon="upload" />
                                  </span>
                                  <span class="file-label">
                                    Seleziona file
                                  </span>
                                </span>
                              </label>
                            </div>

                            <div v-if="shippingNote.attachment" class="table-container">
                              <table class="table is-bordered is-striped is-hoverable" style="min-width: 300px; width: 100%; max-width: 800px;">
                                <thead>
                                  <tr>
                                    <th>Link</th>
                                    <th style="width: 122px;"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <a :href="baseUrl + '/uploads/' + shippingNote.attachment" target="_blank">{{shippingNote.attachment}}</a>
                                    </td>
                                    <td>
                                      <button class="button is-danger" type="button" @click="deleteFile(shippingNote)" title="Elimina">
                                        <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button class="button is-danger" type="button" @click="order.shippingNotes = order.shippingNotes.filter((s, sIndex) => sIndex !== index)" title="Elimina" :disabled="shippingNote.attachment">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="order.shippingNotes.length === 0">
                          <td colspan="100" class="has-text-centered has-text-grey">
                            <i>Nessun risultato</i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputTextarea name="Note" v-model="order.notes" />
          </div>

          <div class="column is-full">
            <div class="field is-grouped is-grouped-centered buttons">
              <button @click="goBack()" class="button is-light" type="button"><font-awesome-icon icon="times" />Chiudi</button>
              <button v-if="$store.getters.amAdmin" class="button is-primary" :class="[{'is-loading': disabledSave}]" type='submit' :disabled="disabledSave"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>
        </form>

        <Modal :title="'Seleziona prodotto'" :openModal="openModalProduct" @close="openModalProduct = false" :saveLabel="'Aggiungi'" @success="addProducts" :disabled="selected?.length <= 0">
          <div class="columns is-multiline">
            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Produttore" v-model="searchProduct.brand" />
            </div>

            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Codice" v-model="searchProduct.code" />
            </div>

            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Descrizione" v-model="searchProduct.name" />
            </div>

            <div class="column is-12">
              <div class="buttons">
                <button class="button is-primary" @click="startSearchProduct()" :class="[{'is-loading': searchLoading}]" :disabled="searchLoading"><font-awesome-icon icon="search" />Cerca</button>
                <button class="button is-success" @click="startAddProduct()"><font-awesome-icon icon="plus" />Nuovo</button>
              </div>
            </div>
          </div>

          <div class="b-table has-pagination" :class="{'is-loading': searchLoading}">
            <div class="table-wrapper has-mobile-cards">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                <tr>
                  <th style="width: 60px;"></th>
                  <th>Produttore</th>
                  <th>Codice</th>
                  <th>Descrizione</th>
                  <th>Unità</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, index) in searchProductResult" :key="index">
                    <td>
                      <label class="checkbox">
                        <input type="checkbox" v-model="record.selected">
                      </label>
                    </td>
                    <td>
                      {{ record.brand }}
                    </td>
                    <td>
                      {{ record.code }}
                    </td>
                    <td>
                      {{ record.name }}
                    </td>
                    <td>
                      {{ record.unit }}
                    </td>
                  </tr>
                  <tr v-if="searchProductResult.length === 0">
                    <td colspan="100" class="has-text-centered has-text-grey">
                      <i>Nessun risultato</i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal>

        <Modal :title="'Aggiungi prodotto'" :openModal="openModalAddProduct" @close="openModalAddProduct = false" @success="saveNewProduct" :disabled="disabledSaveNewProduct">
          <div class="columns is-multiline">
            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Produttore" v-model="addProduct.brand" required />
            </div>

            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Codice" v-model="addProduct.code" required />
            </div>

            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Descrizione" v-model="addProduct.name" />
            </div>

            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Unità" v-model="addProduct.unit" />
            </div>

            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputTextarea name="Note" v-model="addProduct.notes" />
            </div>
          </div>
        </Modal>

        <Modal :title="'Ricerca appuntamento'" :openModal="addOperationModal" @close="closeAddOperationModal" @success="addOperation()" style="width: 95%;" :disabled="!addOperationSelected">
          <OperationList :isSelection="true" @selected="value => selectedOperation(value)" v-if="addOperationModal" />
        </Modal>

        <Modal :title="'Vendita diretta'" :openModal="addDirectModal" @close="addDirectModal = false" @success="addDirect()">
          <div class="columns is-multiline">
            <div class="column is-12-mobile is-6-tablet">
              <InputText name="Data" type="date" v-model="addDirectInfo.date" required />
            </div>

            <div class="column is-12-mobile is-6-tablet">
              <InputText name="Nome e congnome / Ragione sociale" v-model="addDirectInfo.name" required />
            </div>

            <div class="column is-12-mobile is-6-tablet">
              <InputText name="Indirizzo" v-model="addDirectInfo.address" />
            </div>

            <div class="column is-12-mobile is-6-tablet">
              <InputText name="Codice fiscale" v-model="addDirectInfo.cf" />
            </div>

            <div class="column is-12-mobile is-6-tablet">
              <InputText name="Partita IVA" v-model="addDirectInfo.vat" />
            </div>

            <div class="column is-12-mobile is-6-tablet">
              <InputText name="SDI" v-model="addDirectInfo.sdi" />
            </div>

            <div class="column is-12-mobile is-6-tablet">
              <InputText name="Email" v-model="addDirectInfo.email" />
            </div>
          </div>
        </Modal>

        <Modal :title="'Modifica prezzo prodotto'" :openModal="editPriceModal" @close="editPriceModal = false" @success="saveCustomPrice()">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="notification is-info is-light">
                <p><strong>Prezzo di listino:</strong> € {{editPriceProduct?.lastSalePrice || editPriceProduct?.price || '0.00'}}</p>
                <p class="mt-2"><strong>Prodotto:</strong> {{editPriceProduct?.brand}} {{editPriceProduct?.code}} {{editPriceProduct?.name}}</p>
              </div>
            </div>
            <div class="column is-12">
              <InputText name="Prezzo personalizzato" v-model="editPriceValue" type="number" step="0.01" required />
            </div>
            <div class="column is-12-mobile is-6-tablet">
              <InputSelect
                name="IVA"
                v-model="editPriceVat"
                :options="vatOptions"
              />
            </div>
            <div class="column is-12" v-if="editPriceValue">
              <div class="notification is-success is-light">
                <p><strong>Totale ivato:</strong> € {{ calcEditedLinkVatTotal() }}</p>
              </div>
            </div>
          </div>
        </Modal>

      </div>
    </transition>
  </div>
</template>

<script>
import Compressor from 'compressorjs'
import { ObjectId } from 'bson'

import OperationList from './OperationList'

import utils from '../utils'

export default {
  components: {
    OperationList
  },

  data() {
    return {
      baseUrl: import.meta.env.VITE_SERVER,

      order: {
        products: [],
        shippingNotes: []
      },

      tabActive: 'info',

      disabledSave: false,

      init: {
        name: false
      },

      openModalProduct: false,
      searchProduct: {},
      searchProductResult: [],
      searchLoading: false,

      openModalAddProduct: false,
      addProduct: {},
      disabledSaveNewProduct: false,

      addOperationModal: false,
      addOperationSelected: null,
      addOperationProduct: null,
      
      addDirectModal: false,
      addDirectProduct: null,
      addDirectInfo: {},

      editPriceModal: false,
      editPriceLink: null,
      editPriceProduct: null,
      editPriceValue: '',
      editPriceVat: '22',

      vatOptions: ['10', '22']
    }
  },

  computed: {
    selected() {
      const result = this.searchProductResult.filter(product => {
        if (product.selected) {
          return true
        }
      })
      return result
    }
  },

  methods: {
    saveOrder() {
      const self = this
      this.disabledSave = true

      this.$http.post('/order', this.order)
      .then(function (response) {
        utils.deleteDraft(self, self.order._timestamp, 'order').then(() => {
          const createdId = response?.data?._id
          if (createdId) {
            self.$router.replace('/ordini/' + createdId)
          } else {
            self.$router.push('/ordini')
          }
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    updateOrder() {
      const self = this
      this.disabledSave = true

      this.$http.put('/order/' + this.order._id, this.order)
      .then(function (response) {
        utils.deleteDraft(self, self.order._timestamp, 'order').then(() => {
          self.disabledSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    goBack() {
      this.$store.commit('setForm', {name: 'order', value: false})
      this.$router.back()
    },

    selectProduct() {
      this.openModalProduct = true
    },

    startSearchProduct() {
      const self = this
      
      this.searchLoading = true

      const brand = this.searchProduct.brand
      const code = this.searchProduct.code
      const name = this.searchProduct.name

      this.$http.get('/product', { params: {
        //page: args.page,
        size: -1,
        brand,
        code,
        name,
      } }).then(response => {
        if (response && response.data) {
          self.searchProductResult = response.data.records
        }

        self.searchLoading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.searchLoading = false
      })
    },

    addProducts() {
      this.selected.forEach(s => {
        this.order.products.push({
          product: s._id,
          brand: s.brand,
          code: s.code,
          name: s.name,
          unit: s.unit,
          lastSalePrice: s.lastSalePrice || null,
          lastSaleDiscount: s.lastSaleDiscount || null
        })
      })

      this.searchProductResult = []
      this.openModalProduct = false
    },

    startAddProduct() {
      this.openModalAddProduct = true
    },

    saveNewProduct() {
      const self = this
      this.disabledSaveNewProduct = true

      this.$http.post('/product', this.addProduct)
      .then(function (response) {
        const newProduct = response.data

        self.order.products.push({
          product: newProduct._id,
          brand: newProduct.brand,
          code: newProduct.code,
          name: newProduct.name,
          unit: newProduct.unit,
          lastSalePrice: newProduct.lastSalePrice || null,
          lastSaleDiscount: newProduct.lastSaleDiscount || null
        })

        self.disabledSaveNewProduct = false
        self.openModalAddProduct = false
        self.addProduct = {}

        self.searchProductResult = []
        self.openModalProduct = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSaveNewProduct = false
      })
    },

    openAddOperationModal(product) {
      this.addOperationProduct = product
      this.addOperationModal = true
    },

    closeAddOperationModal() {
      this.addOperationModal = false
      this.selectedOperation(null)
    },

    selectedOperation(value) {
      this.addOperationSelected = value
    },

    addOperation() {
      this.addOperationProduct.linked.push({
        operation: this.addOperationSelected,
        quantity: 1,
        customPrice: null,
        vat: '22'
      })
      this.addOperationModal = false
    },

    removeOperationFromOrder(product, index) {
      product.linked.splice(index, 1)
    },

    openAddDirectModal(product) {
      this.addDirectProduct = product
      this.addDirectModal = true
    },

    addDirect() {
      this.addDirectProduct.linked.push({
        direct: this.addDirectInfo,
        quantity: 1,
        customPrice: null,
        vat: '22'
      })
      this.addDirectModal = false
      this.addDirectInfo = {}
    },

    async openEditPriceModal(link, product) {
      this.editPriceLink = link
      this.editPriceProduct = product
      this.editPriceValue = link.customPrice || product.lastSalePrice || product.price || ''
      this.editPriceVat = this.normalizeVat(link.vat)
      this.editPriceModal = true

      if (!link.customPrice) {
        const productId = product?.product
        if (productId) {
          try {
            const response = await this.$http.get('/product/' + productId + '/history')
            const history = response?.data || []
            if (history.length && history[0]?.price) {
              this.editPriceValue = history[0].price
            }
          } catch (error) {
            console.log(error)
          }
        }
      }
    },

    async saveCustomPrice() {
      this.editPriceLink.customPrice = this.editPriceValue
      this.editPriceLink.vat = this.normalizeVat(this.editPriceVat)
      this.editPriceModal = false

      if (this.order?._id) {
        try {
          await this.$http.put('/order/' + this.order._id, this.order)
        } catch (error) {
          console.log(error)
          alert('Errore')
        }
      }

      this.editPriceLink = null
      this.editPriceProduct = null
      this.editPriceValue = ''
      this.editPriceVat = '22'
    },

    compressFile(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.7,
          maxWidth: 2400,
          maxHeight: 2400,
          success(result) {
            if (file.webkitRelativePath) {
              result.webkitRelativePath = file.webkitRelativePath
            }
            resolve(result)
          },
          error(err) {
            //alert('Errore compressione immagine')
            //console.log(err)
            resolve(file)
          },
        })
      })
    },

    uploadFile(shippingNote) {
      const self = this

      const file = this.$refs.inputFiles[0].files[0]

      self.compressFile(file).then(result => {
        const formData = new FormData()
        formData.append('file', result, result.name)

        this.$http.post('/file/order/' + this.order._id + '/' + shippingNote._id, formData)
        .then(function (response) {
          shippingNote.attachment = response.data
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
        })
      })
    },

    deleteFile(shippingNote) {
      this.$http.delete('/file/order/' + this.order._id + '/' + shippingNote._id)
      .then(function (response) {
        shippingNote.attachment = null
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    addShippingNote() {
      this.order.shippingNotes.push({
        _id: new ObjectId().toString(),
        date: new Date().toDateInputValue(),
        notes: '',
        attachment: null
      })
    },

    removeShippingNote(index) {
      this.order.shippingNotes.splice(index, 1)
    },

    calcDiscountedPrice(product) {
      if (product.price) {
        const price = product.price?.replace('€', '')?.trim().replace(',', '.')
        const discount = product.discount

        if (isNaN(price) || isNaN(discount)) {
          return ''
        }

        return (price - (price * discount / 100)).toFixed(2)
      } else {
        return ''
      }
    },

    calcProductTotal(product) {
      const discountedPrice = this.calcDiscountedPrice(product)
      const quantity = product.quantity || 1
      
      if (discountedPrice && !isNaN(discountedPrice)) {
        return '€ ' + (discountedPrice * quantity).toFixed(2)
      } else {
        return '€ 0.00'
      }
    },

    calcOrderTotal() {
      let total = 0
      this.order.products.forEach(product => {
        const discountedPrice = this.calcDiscountedPrice(product)
        const quantity = product.quantity || 1
        
        if (discountedPrice && !isNaN(discountedPrice)) {
          total += discountedPrice * quantity
        }
      })
      
      return '€ ' + total.toFixed(2)
    },

    normalizeVat(vat) {
      const parsedVat = parseFloat(vat)
      if (parsedVat === 10 || parsedVat === 22) {
        return String(parsedVat)
      }
      return '22'
    },

    getValidVat(vat) {
      const parsedVat = parseFloat(vat)
      if (parsedVat === 10 || parsedVat === 22) {
        return String(parsedVat)
      }
      return null
    },

    getVatMultiplier(vat) {
      const normalizedVat = parseFloat(this.normalizeVat(vat))
      return 1 + (normalizedVat / 100)
    },

    calcLinkedVatTotal(link, product) {
      const validVat = this.getValidVat(link?.vat)
      if (!validVat) {
        return null
      }

      const rawPrice = (link?.customPrice || product?.lastSalePrice || product?.price || 0).toString().replaceAll('€', '').trim().replace(',', '.')
      const price = parseFloat(rawPrice || 0)
      const quantity = parseFloat(link?.quantity || 1)
      if (isNaN(price) || isNaN(quantity)) {
        return '0.00'
      }
      return (price * quantity * this.getVatMultiplier(validVat)).toFixed(2)
    },

    calcEditedLinkVatTotal() {
      const price = parseFloat(this.editPriceValue || 0)
      const quantity = parseFloat(this.editPriceLink?.quantity || 1)
      if (isNaN(price) || isNaN(quantity)) {
        return '0.00'
      }
      return (price * quantity * this.getVatMultiplier(this.editPriceVat)).toFixed(2)
    },

    normalizeLinkedVat() {
      if (!Array.isArray(this.order?.products)) {
        return
      }

      this.order.products.forEach(product => {
        if (!Array.isArray(product?.linked)) {
          return
        }

        product.linked.forEach(link => {
          link.vat = this.getValidVat(link?.vat)
        })
      })
    }
  },

  watch: {
    order: {
      handler(value) {
        utils.prepareDraft(this, this.order, value, 'order')
      },
      deep: true
    }
  },

  mounted() {
    const self = this

    const id = this.$route.params.id

    if (id) {
      this.$http.get('/order/' + id)
      .then(function (response) {
        self.order = response.data
        self.normalizeLinkedVat()

        if (self.order.supplier) {
          self.init.name = self.order.supplier
        }
        if (self.order.date) {
          self.init.subname = new Date(self.order.date).toDisplay()
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      if (this.$store.getters.getForm('order')) {
        self.order = this.$store.getters.getForm('order')
        self.normalizeLinkedVat()
      } else {
        const today = new Date()

        this.order.date = today.toDateInputValue()
        this.order.user = this.$store.getters.users.find(user => user._id === this.$store.state.user._id)
      }
    }
  }
}
</script>